/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
  Container,
  Row,
  Modal,
  Button,
  FormGroup,
  Input,
  InputGroup,
} from "reactstrap";
// core components
import Header from "components/Headers/Header.js";
import { axiosGet, axiosPost } from "util/apiConfig.js";
import "./TeachersAvailability.css";
import { fetchTimeSlots } from "util/timeSlot";
import { fetchTimeZones } from "util/timeZones";
import Select from 'react-select';
import AvailabilityContent from "./AvailabilityContent"
class TeachersAvailability extends React.Component {
  constructor(props) {
    super(props);
    this.defaultStartTime = "10:00 am";
    this.defaultEndTime = "08:00 pm";
    this.timing = [];
    this.defaultObj = {
      start: this.defaultStartTime,
      end: this.defaultEndTime,
      isActive: true,
      isChecked: false,
    };
    this.defaultAvailability = [
      { mon: [this.defaultObj] },
      { tue: [this.defaultObj] },
      { wed: [this.defaultObj] },
      { thu: [this.defaultObj] },
      { fri: [this.defaultObj] },
      { sat: [this.defaultObj] },
      { sun: [this.defaultObj] },
    ];
    this.state = {
      timeZones: [],
      timeZone: null,
      teachersList: [],
      selectedDays: [],
      currentTeacher: null,
      currentTeacherName: null,
      currentTeacherAvailability: [],
      Availability: this.defaultAvailability,
      loading: false,
      errorModal: false,
      successModal: false,
      message: "",
      timeZoneError: false,
      currentTeacherError: false,
    };
  }
  componentDidMount() {
    this.setState(
      {
        teachersList: [],
        currentTeacher: null,
        currentTeacherName: null,
        currentTeacherAvailability: [],
      },
      () => {
        this.getAllTeachers();
        this.timing = fetchTimeSlots();
        this.getTimeZones();
      }
    );
  }

  getTimeZones = () => {
    let timeZones = fetchTimeZones();
    let newTimeZoneObj = [];
    timeZones.map((data) => {
      let tt = {value:data, label: data.replace("_", " ") }
      newTimeZoneObj.push(tt)
    })
    timeZones = newTimeZoneObj;
    this.setState({ timeZones });
  };

  // to get all approved teacher's list -
  getAllTeachers = () => {
    let { rowLimit, listPage } = this.state;
    // API --
    axiosGet(`teacher/list-of-all-teacher`)
      .then((response) => {
        if (!response.isError) {
          this.setState({
            teachersList: response.data?.result || [],
          });
        } else {
          this.setState({
            teachersList: [],
          });
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          teachersList: [],
        });
      });
  };

  //Get selected teacher Availability
  getTeacherAvailability = (currentTeacher) => {
    // const defaultSettings = this.defaultAvailability.map((object) => ({
    //   ...object,
    // }));
    const defaultSettings = JSON.parse(JSON.stringify(this.defaultAvailability))
    let selectedDays = [];
    this.setState({ currentTeacher: currentTeacher });
    axiosGet(`teacher/admin-get-teacher-hours/${currentTeacher}`)
      .then((response) => {
        if (!response.isError) {
          if (response.data) {
            const { teacherHoursDetail } = response.data;
            if (teacherHoursDetail) {
              const { mon, tue, wed, thu, fri, sat, sun, localTimeZone } = teacherHoursDetail;
              if (mon && mon.length > 0) {
                selectedDays.push("mon");
                defaultSettings[0]["mon"] = mon;
              }
              if (tue && tue.length > 0) {
                selectedDays.push("tue");
                defaultSettings[1]["tue"] = tue;
              }
              if (wed && wed.length > 0) {
                selectedDays.push("wed");
                defaultSettings[2]["wed"] = wed;
              }
              if (thu && thu.length > 0) {
                selectedDays.push("thu");
                defaultSettings[3]["thu"] = thu;
              }
              if (fri && fri.length > 0) {
                selectedDays.push("fri");
                defaultSettings[4]["fri"] = fri;
              }
              if (sat && sat.length > 0) {
                selectedDays.push("sat");
                defaultSettings[5]["sat"] = sat;
              }
              if (sun && sun.length > 0) {
                selectedDays.push("sun");
                defaultSettings[6]["sun"] = sun;
              }

              this.setState({
                Availability: defaultSettings,
                selectedDays: selectedDays,
                timeZone: localTimeZone ? localTimeZone : null,
              });
            } else {
              this.setState({
                Availability: this.defaultAvailability,
                selectedDays: selectedDays,
                timeZone: null,
              });
            }
          } else {
            this.setState({
              Availability: this.defaultAvailability,
              selectedDays: selectedDays,
              timeZone: null,
            });
          }
        } else {
          this.setState({
            Availability: this.defaultAvailability,
            selectedDays: selectedDays,
            timeZone: null,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          Availability: this.defaultAvailability,
        });
      });
  };

  //Add new timeslot
  addTimeSlot = (dayName) => {
    let { Availability: oldAvailability } = this.state;
    let setNewArray = oldAvailability;
    oldAvailability.map((item, i) => {
      if (Object.keys(item) == dayName[0]) {
        setNewArray[i][dayName[0]].push(this.defaultObj);
      }
    });
    this.setState({
      Availability: setNewArray,
    });
  };

  //Update the times state
  onUpdateTime = (name, dayName, data, iOfItem) => {
    let { Availability } = this.state;
    // let setNewArray =  oldAvailability.map((object) => ({
    //   ...object,
    // }));
    let setNewArray = JSON.parse(JSON.stringify(Availability))
    setNewArray.map((item, i) => {
      if (Object.keys(item) == dayName[0]) {
        setNewArray[i][dayName[0]][iOfItem][name] = data;
      }
    });
    this.setState({
      Availability: setNewArray,
    });
  };

  //Save Availability
  saveAvailability = () => {
    let {
      Availability: oldAvailability,
      currentTeacher,
      currentTeacherName,
      selectedDays,
      timeZone,
    } = this.state;
    if (!currentTeacher) {
      this.setState({
        currentTeacherError: true,
      });
      return;
    }
    if (!timeZone) {
      this.setState({
        timeZoneError: true,
      });
      return;
    }
    

    const [mon, tue, wed, thu, fri, sat, sun] = oldAvailability.map(
      (item) => item
    );
    let requestData = {
      teacherId: currentTeacher,
      teacherName: currentTeacherName,
      localTimeZone: timeZone,
      mon: selectedDays.includes("mon") ? mon.mon : [],
      tue: selectedDays.includes("tue") ? tue.tue : [],
      wed: selectedDays.includes("wed") ? wed.wed : [],
      thu: selectedDays.includes("thu") ? thu.thu : [],
      fri: selectedDays.includes("fri") ? fri.fri : [],
      sat: selectedDays.includes("sat") ? sat.sat : [],
      sun: selectedDays.includes("sun") ? sun.sun : [],
    };

    axiosPost("teacher/admin-add-teacher-hours", requestData)
      .then((response) => {
        if (!response.isError) {
          this.setState(
            {
              loading: false,
              successModal: true,
              message: "Succesfully saved",
            },
            () => {
              this.getTeacherAvailability(currentTeacher);
            }
          );
        } else {
          this.setState({
            loading: false,
            successModal: false,
            errorModal: true,
            message: "Error while saving..",
          });
        }
      })
      .catch((errorResponse) => {
        this.setState({
          loading: false,
          successModal: false,
          errorModal: true,
          message: errorResponse.message,
        });
        console.log("errorResponse", errorResponse);
      });
  };

  //Delete time slot
  deleteTimeSlot = (dayName, data, iOfItem) => {
    let { Availability: oldAvailability } = this.state;
    let setNewArray =  oldAvailability.map((object) => ({
      ...object,
    }));

    setNewArray.map((item, i) => {
      if (Object.keys(item) == dayName[0]) {
        //delete setNewArray[i][dayName[0]][iOfItem];
        setNewArray[i][dayName[0]].splice(iOfItem,1);
      }
    });
    
    this.setState({
      Availability: setNewArray,
    });
  };

  // Modal control -
  toggleModal = (state) => {
    this.setState({
      [state]: !this.state[state],
      modalTitle: "",
      message: "",
    });
  };

  onSetDay = (dayName) => {
    let day = dayName[0];
    const { selectedDays } = this.state;
    if (selectedDays.includes(day)) {
      let index = selectedDays.indexOf(day);
      if (index > -1) {
        selectedDays.splice(index, 1);
      }
    } else {
      selectedDays.push(day);
    }
    this.setState({
      selectedDays: selectedDays,
    });
  };

  render() {
    let {
      teachersList,
      currentTeacher,
      Availability,
      successModal,
      errorModal,
      message,
      modalTitle,
      selectedDays,
      timeZone,
      timeZones,
      timeZoneError,
      currentTeacherError
    } = this.state;
    
    //console.log("this.timing", this.timing);
    //console.log("currentTeacherAvailability", Availability);

    return (
      <>
        <Header />
        {/* Page content */}
        <Container className="mt--7" fluid>
          {/* Table */}
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0 availability-header">
                  <h3 className="mb-0">Teachers Availability</h3>
                  <FormGroup  className={timeZoneError ? "has-danger availability-formgroup" : " availability-formgroup"}>
                      <label className="timezone-lable">Time Zone</label>
                      <InputGroup className="input-group-alternative">
                        {/* <Input
                          type="select"
                          name="timeZone"
                          value={timeZone}
                          onChange={(e) =>
                            this.setState({
                              timeZone: e.target.value,
                              timeZoneError: false,
                            })
                          }
                        >
                          <option>Select time zone</option>
                          {timeZones &&
                            timeZones.map((value, index) => {
                              return (
                                <option key={index} value={value}>
                                  {value}
                                </option>
                              );
                            })}
                        </Input> */}

                      <div style={{width: '100%', minWidth:'200px'}}>
                      <Select
                        options={timeZones}
                        placeholder="Select timezone"
                        value={timeZone ? {value:timeZone,label:timeZone} : timeZone}
                        onChange={(e) =>
                          this.setState({ timeZone: e.value, timeZoneError: false, })
                        }
                        isSearchable={true}
                      />
                      </div>
                      </InputGroup>
                    </FormGroup>
                   
                </CardHeader>
                <div className="availability-hr-main">
                  <div className="availability-title ">
                    <h2>Availability Hours</h2>
                  </div>
                 
                  <div className={currentTeacherError ? "has-danger availability-tab" : "availability-tab"} >
                    {teachersList &&
                      teachersList.length > 0 &&
                      teachersList.map((_data) => {
                        return (
                          <button
                            onClick={() => {
                              this.setState({ currentTeacherName: _data.name, currentTeacherError: false });
                              this.getTeacherAvailability(_data.teacherId);
                            }}
                            className={`${
                              currentTeacher == _data.teacherId ? "active" : ""
                            }`}
                          >
                            {_data.name}
                          </button>
                        );
                      })}
                  </div>
                  
                  <AvailabilityContent
                    Availability={Availability}
                    selectedDays={selectedDays}
                    timing={this.timing}
                    onSetDay={this.onSetDay}
                    onUpdateTime={this.onUpdateTime}
                    addTimeSlot={this.addTimeSlot}
                    deleteTimeSlot={this.deleteTimeSlot}
                    saveAvailability={this.saveAvailability}
                  />
                </div>

                
              </Card>
            </div>
          </Row>

          <Modal
            className="modal-dialog-centered"
            isOpen={this.state.successModal || this.state.errorModal}
            toggle={() =>
              successModal
                ? this.toggleModal("successModal")
                : errorModal
                ? this.toggleModal("errorModal")
                : null
            }
          >
            <div className="modal-header">
              <h5 className="modal-title" id="successModalLabel">
                {modalTitle}
              </h5>
              <button
                aria-label="Close"
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() =>
                  successModal
                    ? this.toggleModal("successModal")
                    : errorModal
                    ? this.toggleModal("errorModal")
                    : null
                }
              >
                <span aria-hidden={true}>×</span>
              </button>
            </div>
            {this.state.successModal ? (
              <div className="modal-body" style={{ color: "green" }}>
                {message}
              </div>
            ) : this.state.errorModal ? (
              <div className="modal-body" style={{ color: "red" }}>
                {message}
              </div>
            ) : null}
            <div className="modal-footer">
              <Button
                color="primary"
                type="button"
                onClick={() =>
                  successModal
                    ? this.toggleModal("successModal")
                    : errorModal
                    ? this.toggleModal("errorModal")
                    : null
                }
              >
                Ok
              </Button>
            </div>
          </Modal>
        </Container>
      </>
    );
  }
}

export default TeachersAvailability;
